'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _strategies = require('./strategies');

var _strategies2 = _interopRequireDefault(_strategies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reset = function reset(_ref) {
  var _ref$event = _ref.event;
  var event = _ref$event === undefined ? 'onDoubleClick' : _ref$event;
  var _ref$getSortingColumn = _ref.getSortingColumns;
  var getSortingColumns = _ref$getSortingColumn === undefined ? function () {
    return [];
  } : _ref$getSortingColumn;
  var _ref$onReset = _ref.onReset;
  var onReset = _ref$onReset === undefined ? function () {} : _ref$onReset;
  var _ref$strategy = _ref.strategy;
  var strategy = _ref$strategy === undefined ? _strategies2.default.byIndex : _ref$strategy;
  return function (value, extra) {
    return _defineProperty({}, event, function () {
      var sortingColumns = getSortingColumns();

      if (!sortingColumns || !Object.keys(sortingColumns).length) {
        return;
      }

      var field = extra[strategy.fieldName];

      var position = sortingColumns[field].position;
      var newSortingColumns = {};

      delete sortingColumns[field];

      Object.keys(sortingColumns).forEach(function (k) {
        var column = sortingColumns[k];

        if (column.position > position) {
          newSortingColumns[k] = _extends({}, column, {
            position: column.position - 1
          });
        } else {
          newSortingColumns[k] = column;
        }
      });

      onReset({
        sortingColumns: newSortingColumns
      });
    });
  };
};

exports.default = reset;


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-sort/dist/reset.js
// module id = 1411
// module chunks = 0